import {JSX, JSXElement} from "../../../helpers/react.js";
import {getQueryMap, handleFetchError} from "../../../helpers/functions.js";
import FilterCell from "../FilterCell.js";
import {ISelectValue, Select} from "../../elements/Select.js";
import {userPermissions} from "../../../config.js";
import TextInput from "../../elements/TextInput.js";
import AbstractFiltersForm from "../AbstractFiltersForm.js";
import {UsersSearchGetParams} from "../../../../../../nodeserver/structs/getparams";
import {FilterPage} from "../anime/FilterPage";
import { ServerApi } from "../../../api.js";
import {FilterUsersPage} from "./FilterUsersPage.js";

const orderBy = [
    {title: 'дате регистрации (сначала новые)', value: 'regdate_desc'},
    {title: 'дате регистрации (сначала старые)', value: 'regdate_asc'},
    {title: 'дате последнего онлайна (сначала новые)', value: 'lastonline_desc'},
    {title: 'дате последнего онлайна (сначала старые)', value: 'lastonline_asc'},
    {title: 'имени (от А до Я)', value: 'a_z'},
    {title: 'имени (от Я до А)', value: 'z_a'},

] as const;
interface Data{
    name?: string;
    ip?: string;
    ipv6?: string;
    user_group?: string[]
    gender?: 'all'|'m'|'w';
    order_by?: string;
}
type BuildModel = Omit<Omit<UsersSearchGetParams, 'limit'>, 'offset'>
export default class FilterUsersForm extends AbstractFiltersForm<{ }, BuildModel, Data>{
    static initialized=false;
    constructor(props: any, ctx: any) {
        super(props, ctx);
        if(location.pathname.startsWith("/users/filter") && !([FilterUsersForm.initialized, FilterUsersForm.initialized=true][0]))
            setTimeout(this.filter);

    }

    render(){
        return (
            <div>
                <div className="filter-body users-body">
                    <FilterCell label="Ник">
                        <TextInput placeholder="Полный ник или часть"
                                   pattern={/^[a-zA-Z]+[a-zA-Z0-9._ ]*/} name="name" autocomplete="off" value={this.params.name}
                                   onChange={this.onVariableChange('nickname')}/>
                    </FilterCell>
                    <FilterCell label="Группа">
                        <Select name="user_group[]" multiple={true} placeholder="Группа пользователя" onChange={this.onSelectChange('groups')}>
                            {
                                ...Object.entries(userPermissions).map(([id, title])=>({
                                    selected: this.params.user_group?.includes(id)??false,
                                    name: title,
                                    value: id
                                } as ISelectValue))
                            }
                        </Select>
                    </FilterCell>
                    <FilterCell label="Пол">
                        <Select name="gender" placeholder="Пол пользователя" multiple={false} onChange={
                            v=>this.onVariableChange('sex')(v?.value??'all')
                        }>
                            {
                                ...[['all','Все'],['m','Мужской'],['w','Женский']].map(([id, title])=>({
                                    selected: id===(['w','m'].includes(this.params.gender!)?this.params.gender:'all'),
                                    name: title,
                                    value: id
                                } as ISelectValue))
                            }
                        </Select>
                    </FilterCell>
                    <FilterCell label="Сортировать по" className="sort-cell">
                        <Select name="order_by" placeholder="Пол пользователя" multiple={false} onChange={v=>this.onVariableChange('order_by')(v?.value??undefined)} direction="up">
                            {
                                ...orderBy.map(({value, title})=>({
                                    selected: value===this.params.order_by,
                                    name: title,
                                    value
                                } as ISelectValue))
                            }
                        </Select>
                    </FilterCell>
                    {(this.params.ip || this.params.ipv6) &&
                        <>
                            <FilterCell label="IP адрес">
                                <TextInput placeholder="IP адрес"
                                           name="ip" autocomplete="off" value={this.params.ip||""}
                                           onChange={this.onVariableChange('ip')}/>
                            </FilterCell>
                            <FilterCell label="IPV6 адрес">
                                <TextInput placeholder="IPV6 адрес"
                                           name="ipv6" autocomplete="off" value={decodeURIComponent(this.params.ipv6||"")}
                                           onChange={this.onVariableChange('ipv6')}/>
                            </FilterCell>

                        </>
                    }
                </div>
                <div className="filter-footer bordered-bottom">
                    <div className="materiable bordered filter-button list" onClick={this.filter}><i className="fa fa-filter" /> Искать</div>
                </div>
            </div>
        );
    }
    override filter = async ()=>{
        if(this.element.classList.contains('blocked')) return;
        this.element.classList.add('blocked');
        if(!location.pathname.startsWith('/users/filter')){
            location.href = `/users/filter?${this.buildParams()}`;
            return;
        }
        else {
            try {
                this.element.classList.add('blocked');
                history.pushState(null, "", "/users/filter?"+this.buildParams());
                $('.content-page').html(
                    <div className="center">
                        <i className="loading fa large" />
                    </div>
                );
                const filters: UsersSearchGetParams = {
                    ...this.filters,
                    limit: 24,
                    offset: 0
                }
                const {items: users, offset, limit} = await ServerApi.users.filter(filters);
                $(".content-page").text('')[0]!.appendChild(
                    <FilterUsersPage users={users} filters={{...this.filters, limit: limit, offset: offset}}/>
                )

            }
            catch (e){
                handleFetchError(e);
            }
            finally {
                this.element.classList.remove('blocked');
            }

        }
    }
}
